<div id="relatorio-guias" class="container-fluid">
  <h3>Painel de Manifestos de Transferência e Devolução</h3>
  <mat-card>
    <mat-card-header class="header-padrao">
      <mat-card-title>
        <form class="d-flex align-items-center filtros-header" [formGroup]="panelForm">
          <mat-form-field>
            <mat-label>Regional:</mat-label>
            <mat-select formControlName="regionalIds" placeholder="Regionais" multiple required
              (selectionChange)="searchAgente()" [disableControl]="isDisabledRegional">
              <mat-option><ngx-mat-select-search [formControl]="regionalMultiFilter" placeholderLabel="Buscar..."
                  noEntriesFoundLabel="Nenhum resultado encontrado..."></ngx-mat-select-search></mat-option>
              <mat-option *ngFor="let regional of filteredRegionais | async" [value]="regional?.id">
                {{ regional?.nome }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Agente:</mat-label>
            <mat-select formControlName="agenteIds" placeholder="Agentes" required
              [disableControl]="isDisabledAgente || !regionalIds" multiple>
              <mat-option><ngx-mat-select-search [formControl]="agenteMultiFilter" placeholderLabel="Buscar..."
                  noEntriesFoundLabel="Nenhum resultado encontrado..."></ngx-mat-select-search></mat-option>
              <mat-option *ngFor="let agente of filteredAgentes | async" [value]="agente?.id"
                [matTooltip]="agente.nome">
                {{ agente?.nome }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Situação</mat-label>
            <mat-select formControlName="tipoSituacaoVisualizacaoId" (selectionChange)="updateCardsFlags()">
              <mat-option selected value="0">Todos</mat-option>
              <mat-option value="1">Pendentes</mat-option>
              <mat-option value="2">Baixados</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Manifesto de Embarque</mat-label>
            <mat-select formControlName="necessarioME" required [disableControl]="modeloFiltroPainelManifesto !== '1'">
              <mat-option selected value="-1">Todos</mat-option>
              <mat-option value="1">Com Manifesto de Embarque</mat-option>
              <mat-option value="0">Sem Manifesto de Embarque</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Tipo de Manifesto</mat-label>
            <mat-select formControlName="tipoManifesto">
              <mat-option selected value="Todos">Todos</mat-option>
              <mat-option value="Transferencia">Transferência</mat-option>
              <mat-option value="Devolucao">Devolução</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="first-filter">
            <mat-label>Número do Manifesto</mat-label>
            <input #mId matInput somenteNumeros class="number" type="text" maxlength="9"
              formControlName="numeroCompletoManifesto">
          </mat-form-field>

          <mat-form-field>
            <mat-label>De:</mat-label>
            <input matInput autocomplete="off" maskDate [matDatepicker]="dataInicial" formControlName="dataInicial">
            <mat-datepicker-toggle matSuffix [for]="dataInicial"></mat-datepicker-toggle>
            <mat-datepicker #dataInicial></mat-datepicker>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Até:</mat-label>
            <input matInput autocomplete="off" maskDate [matDatepicker]="dataFinal" formControlName="dataFinal">
            <mat-datepicker-toggle matSuffix [for]="dataFinal"></mat-datepicker-toggle>
            <mat-datepicker #dataFinal></mat-datepicker>
          </mat-form-field>


          <mat-form-field>
            <mat-label>Código de Barras</mat-label>
            <input matInput autocomplete="off" formControlName="codigoBarras">
          </mat-form-field>

          <mat-form-field>
            <mat-label>Ordenação</mat-label>
            <mat-select formControlName="ordenacao">
              <mat-option selected value="Id">Id</mat-option>
              <mat-option value="quantidadePedidosAscendente">Quantidade de Pedidos Ascendente</mat-option>
              <mat-option value="quantidadePedidosDescendente">Quantidade de Pedidos Descendente</mat-option>
            </mat-select>
          </mat-form-field>

          <button mat-icon-button class="notification-button" (click)="clearFields()" matTooltip="Limpar Campos">
            <mat-icon fontSet="fas" fontIcon="fa-eraser"></mat-icon>
          </button>

          <button mat-icon-button class="notification-button" (click)="search()" [disabled]="panelForm.invalid"
            matTooltip="Pesquisar">
            <mat-icon fontSet="fas" fontIcon="fa-search"></mat-icon>
          </button>
        </form>
        <div #ContainerRef class="d-flex justify-content-center">
          <ngx-charts-number-card *ngIf="cards" [results]="cards" [view]="[ContainerRef.offsetWidth, 180]"
            [scheme]="colorScheme" cardColor="#fefefe" (select)="toggleCards($event)">
          </ngx-charts-number-card>
        </div>
      </mat-card-title>
    </mat-card-header>
    <mat-progress-bar color="primary" mode="indeterminate" [hidden]="!isLoading"></mat-progress-bar>
    <mat-card-content class="no-padding">
      <div>
        <div>
          <table id="relatorios" mat-table [dataSource]="panelCollection" class="table-sm">
            <ng-container matColumnDef="acoes">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let item" width="90px">
                <button mat-button [matMenuTriggerFor]="menu">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item [disabled]="!habilitarBaixa && !habilitarBaixaPainelMT && !habilitarBaixaPainelManifesto" *ngIf="!item.dtBaixa"
                    (click)="baixarManifesto(item)">Baixar</button>
                  <button mat-menu-item [disabled]="item.tipoSituacaoManifesto !== 'Baixado'"
                    (click)="openModalManifestoPedidos(item, item.tipo==='Devolução')"> Visualizar Pedidos</button>
                  <button mat-menu-item [disabled]="!habilitarProrrogacao && !habilitarProrrogacaoPainelMT && !habilitarProrrogacaoPainelManifesto"
                    *ngIf="item.dtBaixa && item.stProrrogSLA !=='Pendente'"
                    (click)="openModalSolicitacao(item, item.tipo==='Devolução')">Solicitar Prorrogação de SLA</button>
                </mat-menu>
                <!-- <button mat-icon-button matTooltip="Editar Evento"
                                    (click)="editEvent(item)">
                                    <mat-icon fontSet="fas" fontIcon="fa-pencil-alt"></mat-icon>
                                </button>
                                <button mat-icon-button matTooltip="Remover Evento"
                                    (click)="removeEvent(item.id);">
                                    <mat-icon fontSet="fas" fontIcon="fa-trash-alt"></mat-icon>
                                </button> -->
              </td>
              <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="manifestoEmbarqueId">
              <th mat-header-cell *matHeaderCellDef class="text-center">Número ME</th>
              <td mat-cell *matCellDef="let item" class="text-center link">
                <a>{{ item.manifestoEmbarqueId}}</a>
              </td>
            </ng-container>

            <ng-container matColumnDef="tipoManifesto">
              <th mat-header-cell *matHeaderCellDef class="text-center">Tipo</th>
              <td mat-cell *matCellDef="let item" class="text-center link">
                <a>{{ item.tipo}}</a>
              </td>
            </ng-container>

            <ng-container matColumnDef="numeroManifesto">
              <th mat-header-cell *matHeaderCellDef class="text-center">Número Manifesto</th>
              <td mat-cell *matCellDef="let item" class="text-center">
                {{ item.numeroManifesto }} </td>
            </ng-container>

            <ng-container matColumnDef="volume">
              <th mat-header-cell *matHeaderCellDef class="text-center">Volume</th>
              <td mat-cell *matCellDef="let item" class="text-center">
                {{ item.volume }} </td>
            </ng-container>

            <ng-container matColumnDef="valor">
              <th mat-header-cell *matHeaderCellDef class="text-center">Valor</th>
              <td mat-cell *matCellDef="let item" class="text-center">
                {{ item.valor | currency:'BRL'}}</td>
            </ng-container>

            <ng-container matColumnDef="tipoSituacaoManifesto">
              <th mat-header-cell *matHeaderCellDef class="text-center">Status</th>
              <td mat-cell *matCellDef="let item" class="text-center">
                {{ item.tipoSituacaoManifesto }} </td>
            </ng-container>

            <ng-container matColumnDef="dtBaixa">
              <th mat-header-cell *matHeaderCellDef class="text-center">Data da Baixa</th>
              <td mat-cell *matCellDef="let item" class="text-center">
                {{ item.dtBaixa | date: 'dd/MM/yyyy HH:mm:ss'}}</td>
            </ng-container>

            <ng-container matColumnDef="usuarioBaixa">
              <th mat-header-cell *matHeaderCellDef class="text-center">Baixado por</th>
              <td mat-cell *matCellDef="let item" class="text-center">
                {{ item.usuarioBaixa }}</td>
            </ng-container>

            <ng-container matColumnDef="dtVencRessalva">
              <th mat-header-cell *matHeaderCellDef class="text-center">Limite SLA</th>
              <td mat-cell *matCellDef="let item" class="text-center">
                {{ item.dtVencRessalva | date: 'dd/MM/yyyy HH:mm:ss'}}</td>
            </ng-container>

            <ng-container matColumnDef="qtdRessalvas">
              <th mat-header-cell *matHeaderCellDef class="text-center">Qtd Ressalvas</th>
              <td mat-cell *matCellDef="let item" class="text-center">
                {{ item.qtdRessalvas }}</td>
            </ng-container>

            <ng-container matColumnDef="stProrrogSLA">
              <th mat-header-cell *matHeaderCellDef class="text-center">St. Prorrog. SLA</th>
              <td mat-cell *matCellDef="let item" class="text-center">
                {{ item.stProrrogSLA }}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        </div>
        <div *ngIf="!isLoading && panelCollection?.data?.length === 0"
          class="d-flex justify-content-center align-items-center" style="height: 100px;">
          Nenhum registro para o período!
        </div>
        <app-paginacao *ngIf="!isLoading && panelCollection?.data?.length != 0" [pageIndex]="paging?.index"
          [pageSize]="paging?.size" [length]="paging?.length" (page)="onPageChange($event)"
          [pageSizeOptions]="[5, 10, 50, 100]">
        </app-paginacao>
      </div>

    </mat-card-content>
  </mat-card>
</div>